import * as React from "react";
import { Container } from "@material-ui/core";
import * as Styles from "./styles/ContainerStyles";
import { RenewalComponent } from "../renewals/RenewalComponent";
import { SecureArea } from "../authentication/SecureArea";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../services/TelemetryService";

function Renewal() {
  const classes = Styles.ContainerStyles();

  return (
    <SecureArea>
      <Container fixed className={classes.container}>
        <RenewalComponent />
      </Container>
    </SecureArea>
  );
}

export default withAITracking(reactPlugin, Renewal, "Renewal");
